// extracted by mini-css-extract-plugin
module.exports = {"PlusButton":"SignButton_PlusButton__hUJON","MinusButton":"SignButton_MinusButton__12kmO","Success":"SignButton_Success__1dais","Danger":"SignButton_Danger__ePRyi"};